import { getAuthorizedApi } from "api/apiInstance";
import { baseInternalUrl } from "api/constants";
import { APIS, SERIES_ID } from "constants/cricket";
import { logger } from "logging/log-util";
// import ColumnDetail from "components/columnDetail";
import { getSession } from "next-auth/react";
import dynamic from "next/dynamic";
const TopicDetail = dynamic(
  () => import("../../../components/topic/topicDetail"),
  { ssr: true }
);

export default function ColumnDetails(props) {
  return <TopicDetail {...props} />;
}

export async function getServerSideProps(ctx) {
  const session = await getSession(ctx);
  const lallantop = JSON.parse(ctx.req?.cookies?.lallantop || "{}");
  const httpClient = await getAuthorizedApi(lallantop.encryptedToken);
  const { topicName } = ctx.params;
  if (!topicName) {
    return {
      notFound: true,
    };
  }
  try {
    const [trendingPostsData, topicData, ramMandirBanner , cricketTopics] = await Promise.all([
      httpClient.get(
        `${baseInternalUrl}/post/trending?limit=5&skip=1&type=audio,video,text`
      ),
      httpClient.get(
        `${baseInternalUrl}/topicItem/getContentBySlug?slug=${topicName}`
      ),
      httpClient.get(
        `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/banner/all?source=WEB&category=topic-page-ram-mandir`
      ),
      httpClient.get(
        `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/topicItem/getContentsBySlugAndType?limit=10&skip=1&slug=champions-trophy&type=text,video`
      ),
    ]);

    let cricketData = null

    const cricketTopicData =  cricketTopics

    if (cricketTopicData && cricketTopicData?.data && cricketTopicData?.data?.result?.entities) {
      cricketData = cricketTopicData?.data?.result?.entities;
    }
    let pointsData = null
    let scoreData = {
      live : null,
      upcoming : null
    }
    const results = await Promise.all([
      httpClient.get(
        `https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_standings/${SERIES_ID}_hn_json`
      ).then(res => {
        return res
      }).catch(err => {
        console.log(err , ' error in the sports.feed points table api ');
        
      }),
      httpClient.get(
        APIS['matches']['live']
      ).then((response) => {
        return response.data
    }).catch(err => {
      console.log(err , ' error in sports.feed live api');
      
    }),
      httpClient.get(
        APIS['matches']['upcoming']
      ).then((response) => {
        return response.data
    }).catch(err => {
      console.log(err , ' error in sports.feed upcoming api');
      
    }),
  
    ])
    if(results[0]?.data){
      pointsData = results[0].data
    }

     //checking if any of the matches are live 
     if(results[1] ){
      scoreData = {
        ...scoreData ,
        live : results[1]
      }
      
    }
    else{
      scoreData = {
        ...scoreData ,
        live : null
      }
      
    }
    //checking if any of the matches are upcoming 
    if(results[2] ){
      scoreData = {
        ...scoreData ,
        upcoming : results[2]
      }
      
    }
    else{
      scoreData = {
        ...scoreData ,
        upcoming : null
      }
      
    }

    try {
      ctx?.res?.setHeader("Cache-Control", `stale-if-error=86400`);
    } catch (error) {
      console.error("cache error", error);
    }
    return {
      props: {
        trendingPostsData: trendingPostsData.data.result.entities,
        topicName,
        topicData: topicData?.data.result,
        ramMandirBanner: ramMandirBanner?.data?.result,
        session,
        pointsData ,
        scoreData,
        cricketData
      }, // will be passed to the page component as props
    };
  } catch (error) {
    logger.error("error,", error);
    return {
      redirect:{
        destination: "/topic",
        permanent: false
      }
    };
  }
}
